import { Component, HostBinding, Input, OnInit } from '@angular/core';

export enum Sizes {
  XX_SMALL = 'fa-2xs',
  X_SMALL = 'fa-xs',
  SMALL = 'fa-sm',
  MEDIUM = '',
  LARGE = 'fa-lg',
  TWO_X = 'fa-2x',
  THREE_X = 'fa-3x',
  FIVE_X = 'fa-5x',
  SEVEN_X = 'fa-7x',
  TEN_X = 'fa-10x',
}

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    standalone: false
})
export class LoadingIndicatorComponent implements OnInit {
  @HostBinding('class') classes = 'flex-column';
  @Input()
  showBackdrop = false;
  @Input()
  fullPage = false;
  @Input()
  blockSection = false;
  @Input()
  size: Sizes = Sizes.MEDIUM;
  @Input()
  message = '';
  @Input()
  minHeight?: string;

  constructor() {}

  ngOnInit(): void {}
}
